<template>
    <div class="form-group">
      <label v-if="label">{{ label }} <span v-if="required">*</span></label>
      <div class="position-relative">
        <b-form-textarea
          :rows="rows"
          :value="displayValue"
          :placeholder="placeholder"
          :disabled="disabled"
          :readonly="(mask && !showReal) || readonly"
          @input="$emit('input', $event)"
        />
        <span v-if="mask" class="toggle-visibility" @click="toggleVisibility">
          <i :class="showReal ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
        </span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "BFormTextareaWithMask",
    props: {
      value: String,
      rows: {
        type: Number,
        default: 3,
      },
      placeholder: String,
      disabled: Boolean,
      label: String,
      required: Boolean,
      readonly: Boolean,
      mask: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        showReal: false,
      };
    },
    computed: {
      displayValue() {
        const val = this.value || "";
        if (!val) return val;
        if (!this.mask) return val;
        if (this.showReal) return val;
        return this.maskText(val);
      },
    },
    methods: {
      toggleVisibility() {
        this.showReal = !this.showReal;
      },
      maskText(text) {
        // masking per karakter, kecuali baris kosong
        return text
          .split("\n")
          .map((line) =>
            line.length <= 2
              ? line
              : line.charAt(0) + "*".repeat(line.length - 2) + line.charAt(line.length - 1)
          )
          .join("\n");
      },
    },
  };
  </script>
  
  <style scoped>
  .toggle-visibility {
    position: absolute;
    top: 8px;
    right: 12px;
    cursor: pointer;
    color: #666;
  }
  </style>


// WEBPACK FOOTER //
// src/components/masking-text-area.vue